<template>
  <div class="award">
    <div class="header">
      <div class="matchName overellipsis">{{state.matchInfo.matchName}}</div>
      <div class="projectInfo overellipsis">{{state.projectInfo.groupName}}</div>
      <div class="projectInfo">{{state.projectInfo.matchProjectName}}</div>
    </div>
    <div class="rankingList">
      <router-view  :showData="showList" ></router-view>
    </div>
  </div>
</template>

<script>
import {ref, computed, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import { createState } from "../../store";
export default {
  setup() { 
    console.log(reactive(createState))
    console.log(reactive(createState).showList)
    const data = reactive(createState);
    
    return {
      state: reactive(createState),
      showList:ref(data.showList)
    };
  },
  methods: {
  },
  mounted() {
  },
  created() {},
};
</script>

<style lang="less" scoped>
.rankingList{
  width: 7.5rem;
  min-height: 8rem;
  margin-top: 0.5rem;
}
.overellipsis{
  box-sizing: border-box;
  display: inline-block;
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
}
.projectInfo{
  width: 6.5rem;
  height: 0.6rem;
  color: #fff;
  text-shadow: 2px 2px 2px #ccc;
  text-align: center;
  margin-left: 0.5rem;
  line-height: 0.7rem;
  font-size: 0.36rem;
  font-weight: 700;
 
}
.matchName{
  width: 6.5rem;
  // height: 1.5rem;
  color: #FFFF66;
  text-shadow: 5px 5px 5px #ccc;
  margin-top: 0.5rem;
  text-align: center;
  margin-left: 0.5rem;
  line-height: 0.7rem;
  font-size: 0.4rem;
  font-weight: 700;
}
.award {
  width: 100%;
  height: 100%;
  background-image: url('./banjiang.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
}
</style>